const shared = {
    height: '$avatar',
    width: '$avatar',
}

export const avatar = {
    ...shared,
    boxSizing: 'border-box',
    flex: 'none',
    position: 'relative',
    variants: {
        size: {
            big: {
                height: '$avatarBig',
                width: '$avatarBig',
            },
            mid: {
                height: '$avatarMid',
                width: '$avatarMid',
            },
            small: {
                height: '$avatarSmall',
                width: '$avatarSmall',
            },
        },
    },
}

export const nativeAvatar = {...shared}

const sharedImage = {
    borderRadius: '$avatarBorder',
    height: '100%',
    width: '100%',
}

export const image = {
    ...sharedImage,
    variants: {
        size: {
            big: {borderRadius: '$avatarBigBorder'},
            mid: {borderRadius: '$avatarMidBorder'},
            small: {borderRadius: '$avatarSmallBorder'},
        },
        state: {
            highlight: {
                borderColor: '$avatarBorderHighlight',
                borderStyle: 'solid' as const,
                borderWidth: '$avatar',
                height: 'calc(100% - 4px)',
                width: 'calc(100% - 4px) !important', // TODO: remove important when scss is deprecated
            },
            unread: {
                borderColor: '$avatarBorderUnread',
                borderStyle: 'solid' as const,
                borderWidth: '$avatar',
                height: 'calc(100% - 4px)',
                width: 'calc(100% - 4px) !important', // TODO: remove important when scss is deprecated
            },
        },
    },
    width: '100% !important', // TODO: remove important when scss is deprecated
}

export const nativeImage = {...sharedImage}

const sharedStatus = {
    backgroundColor: '$statusConnected',
    borderColor: '$statusBorder',
    borderRadius: '$avatarStatus',
    borderStyle: 'solid' as const,
    borderWidth: '$avatarStatus',
    height: '$avatarStatus',
    position: 'absolute' as const,
    variants: {status: {idle: {backgroundColor: '$statusIdle'}}},
    width: '$avatarStatus',
}

export const status = {
    ...sharedStatus,
    bottom: '-2px',
    boxSizing: 'border-box',
    right: '-2px',
}

export const nativeStatus = {
    ...sharedStatus,
    bottom: 0,
    right: 0,
}
